'use client';

export { default } from './Popper';
export * from './popperClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Popper/index.js
// module id = 169
// module chunks = 25